import api from '../../../../api';

export const InputSelector = {
  INPUT: api.internals.ns.selector('input-group')
};
